<div class="entrepreneur-prospect-dialog-aligned-accelerators-part">
	<readonly-access [readonly]="dialogDataService.isReadonly()"></readonly-access>
	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()"
		[rows]="alignedAccelerators()"></grid-content>
</div>